"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = exports.insp = exports["default"] = void 0;
var install = function install(wid) {
  window.__insp = window.__insp || [];
  insp(["wid", wid]);
  setTimeout(function () {
    if (typeof window.__inspld != "undefined") return;
    window.__inspld = 1;
    var insp = document.createElement("script");
    insp.type = "text/javascript";
    insp.async = true;
    insp.id = "inspsync";
    insp.src = "".concat("https:" == document.location.protocol ? "https" : "http", "://cdn.inspectlet.com/inspectlet.js?wid=").concat(wid, "&r=").concat(Math.floor(new Date().getTime() / 3600000));
    var x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(insp, x);
  }, 0);
};
exports.install = install;
var insp = function insp() {
  var _window$__insp;
  return (_window$__insp = window.__insp).push.apply(_window$__insp, arguments);
};
exports.insp = insp;
var _default = insp;
exports["default"] = _default;